import React from 'react';
import EditIntegrationMainContent from './EditIntegrationMainContent';

const EditIntegrationSettings: React.FC = () => (
  <div className="flex flex-row  w-full h-full overflow-hidden">
    <EditIntegrationMainContent />
    <div className="mt-4 border-r border-litlingo-gray-2" />
  </div>
);

export default EditIntegrationSettings;
